module.exports = __webpack_public_path__ + "static/media/english1.9326c57c.jpg";